<template>
  <div class="scroll-hidden monitoring-table-wrapper shadow-monitoring">
    <global-loading
      v-if="$store.state.monitoringStore.detail_sio_by_vendor_loading"
    />
    <div
      class="pointer"
      style="position:absolute;right:2%;top:2%;font-size:20px"
    >
      <i
        class="fa-solid fa-file-arrow-down"
        style="color:red"
        @click="downloadReport()"
      ></i>
    </div>
    <div class="text-sm text-bold">
      Detail SIO by Vendor
    </div>
    <div class="mt10">
      <div class="brl-top-table-header border-bottom">
        <div class="brl-top-table-material">
          Vendor Name
          <span class="pointer" @click="vendorSortFunction()">
            <i class="fas fa-arrow-down" v-show="vendorSort"></i
            ><i class="fas fa-arrow-up" v-show="!vendorSort"></i>
          </span>
        </div>
        <div class="brl-top-table-vendor">
          Active
          <span class="pointer" @click="activeSortFunction()">
            <i class="fas fa-arrow-down" v-show="activeSort"></i
            ><i class="fas fa-arrow-up" v-show="!activeSort"></i>
          </span>
        </div>
        <div class="brl-top-table-vendor">
          Not Active
          <span class="pointer" @click="notActiveSortFunction()">
            <i class="fas fa-arrow-down" v-show="notActiveSort"></i
            ><i class="fas fa-arrow-up" v-show="!notActiveSort"></i>
          </span>
        </div>
        <div class="brl-top-table-vendor">
          Total
          <span class="pointer" @click="totalSortFunction()">
            <i class="fas fa-arrow-down" v-show="totalSort"></i
            ><i class="fas fa-arrow-up" v-show="!totalSort"></i>
          </span>
        </div>
      </div>
      <div>
        <div
          class="brl-top-table-header"
          v-for="(item, index) in detailSioByVendor"
          :key="index"
        >
          <div class="brl-top-table-material">
            {{ item.nama_vendor }}
          </div>
          <div class="brl-top-table-vendor">{{ item.active }}</div>
          <div class="brl-top-table-vendor">{{ item.not_active }}</div>
          <div class="brl-top-table-vendor">
            {{ item.total_active_not_active }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as XLSX from 'sheetjs-style'
import moment from 'moment'
export default {
  components: {
    barChart: () => import('@/components/chart/dashboard/bar-chart.vue'),
    GlobalLoading: () => import('@/components/V2/GlobalLoading.vue'),
  },
  data() {
    return {
      listVendor: [
        {
          vendor: 'AZ-Zahra',
          active: 10,
          notActive: 10,
        },
        {
          vendor: 'BUMA',
          active: 9,
          notActive: 9,
        },
        {
          vendor: 'PAMA',
          active: 8,
          notActive: 8,
        },
        {
          vendor: 'UTI',
          active: 7,
          notActive: 7,
        },
        {
          vendor: 'ENJ',
          active: 6,
          notActive: 6,
        },
        {
          vendor: 'SUN',
          active: 5,
          notActive: 5,
        },
        {
          vendor: 'EMI',
          active: 4,
          notActive: 4,
        },
        {
          vendor: 'GEMS',
          active: 3,
          notActive: 3,
        },
      ],
      vendorSort: false,
      activeSort: false,
      notActiveSort: false,
      totalSort: false,
    }
  },

  computed: {
    detailSioByVendor() {
      const data = this.$store.state.monitoringStore.detail_sio_by_vendor

      return data
    },
  },

  methods: {
    vendorSortFunction() {
      this.vendorSort = !this.vendorSort

      if (this.vendorSort) {
        this.detailSioByVendor.sort((a, b) =>
          a.nama_vendor.localeCompare(b.nama_vendor)
        )
      } else {
        this.detailSioByVendor.sort((a, b) =>
          b.nama_vendor.localeCompare(a.nama_vendor)
        )
      }
    },
    activeSortFunction() {
      this.activeSort = !this.activeSort

      this.detailSioByVendor.sort((a, b) => {
        if (this.activeSort) {
          return a.active - b.active
        } else {
          return b.active - a.active
        }
      })
    },
    notActiveSortFunction() {
      this.notActiveSort = !this.notActiveSort

      this.detailSioByVendor.sort((a, b) => {
        if (this.notActiveSort) {
          return a.not_active - b.not_active
        } else {
          return b.not_active - a.not_active
        }
      })
    },
    totalSortFunction() {
      this.total = !this.total

      this.detailSioByVendor.sort((a, b) => {
        if (this.total) {
          return a.total_active_not_active - b.total_active_not_active
        } else {
          return b.total_active_not_active - a.total_active_not_active
        }
      })
    },
    downloadReport() {
      let wb = XLSX.utils.book_new()
      let sheet = ['Detail SIO by Vendor']
      sheet.forEach(list => {
        let dataExport = this.detailSioByVendor
        dataExport.unshift({})
        let dataToExport = XLSX.utils.json_to_sheet(dataExport)
        const title = [
          ['', '', '', '', '', '', '', '', ''],
          ['No', 'Vendor Name', 'Active', 'Not Active', 'Total'],
        ]
        XLSX.utils.book_append_sheet(wb, dataToExport, list)
        XLSX.utils.sheet_add_aoa(dataToExport, title, {
          origin: 'A1',
        })
      })
      XLSX.writeFile(wb, `Detail SIO by Vendor.xlsx`)
    },
  },
}
</script>
